import globalAxios from "../GlobalAxios";

const listApi = async (params) => {
  const res = await globalAxios.get("/api/asset/list", {params});
  return res.data;
};

const allListApi = async (params) => {
  const res = await globalAxios.get("/api/asset/all", {params});
  return res.data;
};

const groupApi = async () => {
  const res = await globalAxios.get("/api/asset/group-list");
  return res.data.list;
};

const inGroupInfoApi = async (asset_id) => {
  const res = await globalAxios.get("/api/asset/asset-inGroup", {params: {asset_id}});
  return res.data.list;
};

const inGroupApi = async (params) => {
  const res = await globalAxios.get("/api/asset/list-inGroup", {params});
  return res.data;
};

const statusApi = async (params) => {
  const res = await globalAxios.get("/api/asset/list-status", {params});
  return res.data.list;
};

const assetDetailApi = async (asset_id) => {
  const res = await globalAxios.get("/api/asset/detail", {params: {asset_id}});
  return res.data;
};

const addGroupApi = async (group_name) => {
  const res = await globalAxios.post("/api/asset/add-group", {group_name});
  return res.data;
};

const addInGroupApi = async (params) => {
  const res = await globalAxios.post("/api/asset/add-inGroup", {params});
  return res.data;
};

const addInGroupSingleApi = async (params) => {
  const res = await globalAxios.post("/api/asset/add-inGroupSingle", {params});
  return res.data;
};

const updateGroupApi = async (params) => {
  const res = await globalAxios.post("/api/asset/update-group", {params});
  return res.data;
};

const deleteGroupApi = async (group_id) => {
  const res = await globalAxios.post("/api/asset/delete-group", {group_id});
  return res.data;
};

const updateInfoApi = async (params) => {
  const res = await globalAxios.post("/api/asset/update", {params});
  return res.data;
};

const addTagApi = async (params) => {
  const res = await globalAxios.post("/api/asset/add-tag", {params});
  return res.data;
};

const deleteTagApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete-tag", {params});
  return res.data;
};

const deleteAllApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete", {params});
  return res.data;
};

const reqEncodeApi = async (params) => {
  const res = await globalAxios.post("/api/asset/req-encode", {params});
  return res.data;
};

const distributionApi = async (params) => {
  const res = await globalAxios.post("/api/asset/distribution", {params});
  return res.data;
};

const uploadTnApi = async (formData) => {
  const res = await globalAxios.post("/api/asset/upload-thumbnail", formData);
  return res.data;
};

const deleteTnApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete-thumbnail", {params});
  return res.data;
};

const delSingleApi = async (params) => {
  const res = await globalAxios.post("/api/asset/delete-single", {params});
  return res.data;
};

const testApi = async () => {
  const res = await globalAxios.get("/api/a/test");
  return res.data;
};

const getAllList = async () => {
  const res = await globalAxios.get("/api/asset/all-list");
  return res.data;
};

const reqCheck = async (params) => {
  const res = await globalAxios.get("/api/asset/check-encoding", {params: params});
  return res.data;
};

const posterApi = async (params) => {
  const res = await globalAxios.get("/api/asset/poster", {params: params});
  return res.data;
};


export default {
    listApi,
    allListApi,
    groupApi,
    inGroupInfoApi,
    inGroupApi,
    statusApi,
    assetDetailApi,
    addGroupApi,
    addInGroupApi,
    updateGroupApi,
    deleteGroupApi,
    updateInfoApi,
    addTagApi,
    deleteTagApi,
    deleteAllApi,
    reqEncodeApi,
    distributionApi,
    uploadTnApi,
    deleteTnApi,
    delSingleApi,
    addInGroupSingleApi,
    testApi,
    getAllList,
    reqCheck,
    posterApi
};